import { render } from "./ViewUser.vue?vue&type=template&id=2774721a"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"
script.render = render

export default script